import React, { useState } from 'react';
import { sendMessage } from '../api';

function ChatBox() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage = { sender: 'user', text: input };
    setMessages([...messages, userMessage]);

    const response = await sendMessage(input);
    const botMessage = { sender: 'bot', text: response.data.response };
    setMessages((prev) => [...prev, botMessage]);
    setInput('');
  };

  return (
    <div className="p-4 max-w-xl mx-auto">
      <div className="bg-white shadow rounded p-4 h-96 overflow-y-auto space-y-2">
        {messages.map((msg, i) => (
          <div key={i} className={`text-sm ${msg.sender === 'user' ? 'text-right' : 'text-left'}`}>
            <div className={`inline-block px-3 py-2 rounded ${msg.sender === 'user' ? 'bg-blue-100' : 'bg-gray-200'}`}>
              {msg.text}
            </div>
          </div>
        ))}
      </div>
      <div className="flex mt-4">
        <input
          className="border flex-1 px-3 py-2 rounded-l"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSend()}
        />
        <button onClick={handleSend} className="bg-blue-500 text-white px-4 py-2 rounded-r">Send</button>
      </div>
    </div>
  );
}

export default ChatBox;
